import {BREAKPOINTS} from 'utilities/breakpoints';
import {makeImageSourceData} from 'components/UIKit/Picture';

import cityDesktop from './city-desktop.jpg';
import cityDesktop2x from './city-desktop2x.jpg';
import cityTablet from './city-tablet.jpg';
import cityTablet2x from './city-tablet2x.jpg';
import cityMobile from './city-mobile.jpg';
import cityMobile2x from './city-mobile2x.jpg';

export const fallbackSubscriptionPictureData = {
  sources: [
    makeImageSourceData(cityMobile, cityMobile2x, BREAKPOINTS.mobile),
    makeImageSourceData(cityTablet, cityTablet2x, BREAKPOINTS.tablet),
    makeImageSourceData(cityDesktop, cityDesktop2x, BREAKPOINTS.desktopUp),
  ],
  fallback: cityTablet2x,
};
